/* The Locket Tree draft relevance policy. Generated from captured rules; not Boost's proprietary scorer. */
(function (global) {
  'use strict';
  var config = {"version":"20261018-policy-v6","synonyms":[{"from":"celtic knot","to":"celtic"},{"from":"daughter","to":"children"},{"from":"multi","to":"4-photo"},{"from":"ladies family locket","to":"family"},{"from":"picture","to":"photo"},{"from":"medaglione","to":"locket"},{"from":"kids","to":"child","both":true},{"from":"kid","to":"child","both":true},{"from":"4 photo","to":"4-photo","both":true},{"from":"4 photo locket","to":"4-photo","both":true}],"heldSynonyms":[{"from":"plated","to":"gold","reason":"Material meaning changes; solid gold is not necessarily plated."},{"from":"aquamarine","to":"turquoise","reason":"Different gemstones."},{"from":"roger","to":"forget","reason":"Unverified intended meaning."}],"customAliases":[{"from":"brown","to":"amber","reason":"Explicit requested colour search acceptance: Amber must remain available for brown; not a captured Boost synonym."}],"rules":[{"key":"boost-4-photo","name":"4 photo locket","condition":"Contain","terms":["4 photo locket","4-Photo Locket","4 photo"],"singularPlural":true,"pins":[{"position":1,"id":"6780353413185","handle":"floral-family-locket","observed":"Premium Floral Family Locket","resolution":"unique-catalog-title"},{"position":2,"id":"6719763054657","handle":"art-nouveau-rose-gold-tree-of-life-family-locket","observed":"Rose Gold Tree of Life 4-Photo Locket","resolution":"unique-catalog-title"},{"position":3,"id":"6564686004289","handle":"rose-gold-4-photo-locket","observed":"Rose Gold 4-Photo Locket","resolution":"unique-catalog-title"},{"position":4,"id":"7417437618241","handle":"traditional-4-way-clover-leaf-locket","observed":"Traditional 4-Way Clover Leaf Locket","resolution":"unique-catalog-title"},{"position":5,"id":"11514326804","handle":"dainty-gold-4-photo-locket","observed":"Dainty Gold 4-Photo Locket","resolution":"unique-catalog-title"},{"position":6,"id":"7122127815","handle":"handmade-victorian-gold-family-locket","observed":"Large Handmade Victorian Gold Family Locket","resolution":"unique-catalog-title"},{"position":7,"id":"6207956487","handle":"petite-gold-4-photo-heart-locket","observed":"Petite Gold 4-Photo Heart Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":["pfs:hidden"],"source":"boost-4-photo.txt"},{"key":"boost-children","name":"kids","condition":"Contain","terms":["kid","kids","daughter"],"singularPlural":true,"pins":[{"position":1,"id":"7333356699713","handle":"hot-pink-enamel-locket","observed":"Hot Pink Enamel Locket","resolution":"unique-catalog-title"},{"position":2,"id":"6557589255","handle":"petite-oval-and-heart-locket","observed":"Petite Oval and Heart Locket","resolution":"unique-catalog-title"},{"position":3,"id":"7105692172353","observed":"7105692172353","resolution":"captured-id-not-in-public-catalog"},{"position":4,"id":"6986966855","handle":"tiny-silver-heart-locket-12mm","observed":"Tiny Silver Heart Locket","resolution":"unique-catalog-title"},{"position":5,"id":"6557064071","handle":"heart-accent-locket","observed":"Heart Accent Locket","resolution":"unique-catalog-title"},{"position":6,"id":"7028943323201","handle":"tiny-round-silver-locket","observed":"Contemporary Flat Tiny Round Locket","resolution":"unique-catalog-title"},{"position":7,"id":"7031345020993","handle":"dainty-rabbit-locket","observed":"Dainty Rabbit Locket","resolution":"unique-catalog-title"}],"boosts":[{"id":"262365959","handle":"childrens-lockets","observed":"Children"}],"hides":[],"hideTags":[],"source":"boost-children.txt"},{"key":"boost-gold","name":"Gold","condition":"Contain","terms":["gold","gold locket"],"singularPlural":true,"pins":[{"position":1,"id":"9479702986","handle":"petite-gold-oval-locket-17-mm","observed":"Gold Oval Locket","resolution":"unique-catalog-title"},{"position":2,"id":"7101842686017","handle":"hand-engraved-border-gold-oval-locket","observed":"Hand Engraved Border Gold Oval Locket","resolution":"unique-catalog-title"},{"position":3,"id":"2015657033793","handle":"hand-engraved-floral-gold-locket-17-mm","observed":"Hand Engraved Floral Gold Locket","resolution":"unique-catalog-title"},{"position":4,"id":"98849980436","handle":"green-guilloche-heart-locket","observed":"Green Guilloche Heart Locket","resolution":"unique-catalog-title"},{"position":5,"id":"6790724845633","handle":"18-ct-petite-black-enamel-and-diamond-locket","observed":"18 ct Petite Black Enamel and Diamond Locket","resolution":"unique-catalog-title"},{"position":6,"id":"7122127815","handle":"handmade-victorian-gold-family-locket","observed":"Large Handmade Victorian Gold Family Locket","resolution":"unique-catalog-title"},{"position":7,"id":"6491623175","handle":"pave-set-diamond-gold-locket","observed":"Pavé Set Diamond Gold Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-gold.txt"},{"key":"boost-heart-locket","name":"heart locket","condition":"Are","terms":["heart locket"],"singularPlural":true,"pins":[{"position":1,"id":"14533197988218","handle":"petite-9ct-flat-gold-heart-locket","observed":"Petite Gold Flat Heart Locket","resolution":"unique-catalog-title"},{"position":2,"id":"6775989239873","handle":"initial-locket","observed":"Initial Locket","resolution":"unique-catalog-title"},{"position":3,"id":"6244758727","handle":"spring-flowers-locket","observed":"18 ct Spring Flowers Gold Locket","resolution":"unique-catalog-title"},{"position":4,"id":"7122966087","handle":"petite-abalone-heart-locket","observed":"Petite Abalone Heart Locket","resolution":"unique-catalog-title"},{"position":5,"id":"6431424327","handle":"tiny-gold-and-diamond-heart-locket","observed":"Tiny Gold and Diamond Heart Locket","resolution":"unique-catalog-title"},{"position":6,"id":"4620521308225","handle":"premium-gold-and-sapphire-heart-locket","observed":"Premium Gold and Sapphire Heart Locket","resolution":"unique-catalog-title"},{"position":7,"id":"6286292999","handle":"blue-guilloche-heart-locket","observed":"Blue Guilloche Heart Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-heart-locket.txt"},{"key":"boost-heart","name":"heart","condition":"Are","terms":["heart"],"singularPlural":true,"pins":[],"boosts":[{"id":"262348551","handle":"heart-lockets","observed":"Heart Lockets"}],"hides":[],"hideTags":[],"source":"boost-heart.txt"},{"key":"boost-locket","name":"Locket","condition":"Contain","terms":["locket","lockets"],"singularPlural":true,"pins":[{"position":1,"id":"119003840532","handle":"plain-silver-heart-locket-18-mm","observed":"Plain Silver Heart Locket","resolution":"unique-catalog-title"},{"position":2,"id":"7325417898049","observed":"7325417898049","resolution":"captured-id-not-in-public-catalog"},{"position":3,"id":"6988354951","handle":"victorian-gold-heart-locket","observed":"Victorian Gold Heart Locket","resolution":"unique-catalog-title"},{"position":4,"id":"7031305011265","handle":"turquoise-and-pearl-petite-round-locket","observed":"Turquoise and Pearl Tiny Round Locket","resolution":"unique-catalog-title"},{"position":5,"id":"14952503247226","handle":"white-mop-heart-19-mm","observed":"Tender White Heart Locket","resolution":"unique-catalog-title"},{"position":6,"id":"7038476877889","handle":"mens-origami-polished-silver-locket","observed":"Men's Origami Polished Silver Locket","resolution":"unique-catalog-title"},{"position":7,"id":"6793860939841","handle":"golden-lovebirds-locket","observed":"Golden Lovebirds Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-locket.txt"},{"key":"boost-medaglione","name":"medaglione","condition":"Are","terms":["medaglione"],"singularPlural":true,"pins":[{"position":1,"id":"7033071829057","handle":"large-round-hammered-locket","observed":"Large Round Hammered Locket","resolution":"unique-catalog-title"},{"position":2,"id":"1551850012737","handle":"premium-gold-compass-locket","observed":"Premium Gold Compass Locket","resolution":"unique-catalog-title"},{"position":3,"id":"1908830273601","handle":"petite-round-micromosaic-locket-18-mm","observed":"Petite Round Micromosaic Locket","resolution":"unique-catalog-title"},{"position":4,"id":"10474187156","handle":"tree-of-life-locket","observed":"Tree of Life Locket","resolution":"unique-catalog-title"},{"position":5,"id":"6565036425281","handle":"premium-gold-compass-locket-1","observed":"Large Round Gold Locket","resolution":"unique-catalog-title"},{"position":6,"id":"6907116423","handle":"hand-engraved-gold-round-border-locket","observed":"Hand Engraved Gold Round Border Locket","resolution":"unique-catalog-title"},{"position":7,"id":"6514436999","handle":"pave-set-diamond-round-locket","observed":"Pavé Set Diamond Round Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-medaglione.txt"},{"key":"boost-oval","name":"oval","condition":"Are","terms":["oval"],"singularPlural":true,"pins":[{"position":1,"id":"14872079204730","handle":"premium-foliate","observed":"Premium Oval Foliate Design Locket","resolution":"unique-catalog-title"},{"position":2,"id":"14622322393466","handle":"forget-me-not-4-photo-locket","observed":"Forget-Me-Not 4-Photo Locket","resolution":"unique-catalog-title"},{"position":3,"id":"7105692172353","observed":"7105692172353","resolution":"captured-id-not-in-public-catalog"},{"position":4,"id":"7037543841857","handle":"tiny-oval-amethyst-locket","observed":"Tiny Oval Amethyst Locket","resolution":"unique-catalog-title"},{"position":5,"id":"6238143879","handle":"mother-of-pearl-and-diamond-locket","observed":"Mother of Pearl and Diamond Locket","resolution":"unique-catalog-title"},{"position":6,"id":"6970772359","handle":"hand-polished-white-gold-oval-locket-19-mm","observed":"Hand Polished White Gold Oval Locket 19 mm","resolution":"unique-catalog-title"},{"position":7,"id":"4308829732929","handle":"rose-gold-floral-oval-locket","observed":"Rose Gold Bouquet Locket","resolution":"unique-catalog-title"}],"boosts":[{"id":"262348679","handle":"oval-lockets","observed":"Oval Lockets"}],"hides":[],"hideTags":[],"source":"boost-oval.txt"},{"key":"boost-silver-heart","name":"silver heart\t","condition":"Are","terms":["silver heart"],"singularPlural":true,"pins":[{"position":1,"id":"14749585703290","handle":"large-contemporary-mother-of-pearl-locket","observed":"Large Contemporary Mother-of-Pearl Locket","resolution":"unique-catalog-title"},{"position":2,"id":"14533199921530","handle":"silver-flat-heart","observed":"Silver Flat Heart Locket","resolution":"unique-catalog-title"},{"position":3,"id":"2027654971457","handle":"vintage-rose-locket-20-mm","observed":"Vintage Rose Locket","resolution":"unique-catalog-title"},{"position":4,"id":"7417437618241","handle":"traditional-4-way-clover-leaf-locket","observed":"Traditional 4-Way Clover Leaf Locket","resolution":"unique-catalog-title"},{"position":5,"id":"1489361535041","handle":"petite-infinity-heart-13-mm","observed":"Petite Infinity Heart","resolution":"unique-catalog-title"},{"position":6,"id":"128264142868","handle":"your-name-diamond-locket-21-mm","observed":"Your Name Diamond Locket","resolution":"unique-catalog-title"},{"position":7,"id":"73614721044","handle":"footprints-in-the-sand-locket-21-mm","observed":"Footprints in the Sand Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-silver-heart.txt"},{"key":"boost-silver","name":"Silver","condition":"Contain","terms":["silver locket","silver"],"singularPlural":true,"pins":[{"position":1,"id":"6983472250945","handle":"classic-silver-heart-locket","observed":"Classic Silver Heart Locket 20 mm","resolution":"unique-catalog-title"},{"position":2,"id":"10466060756","handle":"mens-dogtag-locket-34-mm","observed":"Men's Dog Tag Locket","resolution":"unique-catalog-title"},{"position":3,"id":"6608348184641","handle":"silver-compass-locket","observed":"Silver Compass Locket","resolution":"unique-catalog-title"},{"position":4,"id":"6780353413185","handle":"floral-family-locket","observed":"Premium Floral Family Locket","resolution":"unique-catalog-title"},{"position":5,"id":"6580812546113","handle":"plain-10-photo-book-locket","observed":"10 Photo Plain Book Locket","resolution":"unique-catalog-title"},{"position":6,"id":"14870918431098","handle":"contemporary-mother-of-pearl-heart-locket","observed":"Contemporary Mother-of-Pearl Heart Locket","resolution":"unique-catalog-title"},{"position":7,"id":"14807694246266","handle":"premium-petite-silver-and-diamond-locket","observed":"Premium Petite Silver and Diamond Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-silver.txt"},{"key":"boost-small-locket","name":"small locket","condition":"Are","terms":["small locket"],"singularPlural":true,"pins":[{"position":1,"id":"7384476057665","handle":"sapphire-book-locket","observed":"Sapphire Book Locket","resolution":"unique-catalog-title"},{"position":2,"id":"14807694246266","handle":"premium-petite-silver-and-diamond-locket","observed":"Premium Petite Silver and Diamond Locket","resolution":"unique-catalog-title"},{"position":3,"id":"14533199888762","handle":"small-flat-heart","observed":"Small Flat Silver Heart Locket","resolution":"unique-catalog-title"},{"position":4,"id":"14804000539002","handle":"g647sa","observed":"Tiny Gold and Sapphire Locket","resolution":"unique-catalog-title"},{"position":5,"id":"7210976018497","handle":"tiny-round-paw-prints-locket","observed":"Tiny Round Paw Prints Locket","resolution":"unique-catalog-title"},{"position":6,"id":"7031305011265","handle":"turquoise-and-pearl-petite-round-locket","observed":"Turquoise and Pearl Tiny Round Locket","resolution":"unique-catalog-title"},{"position":7,"id":"7033097093185","handle":"tiny-baby-footprint-locket","observed":"Tiny Baby Footprint Locket","resolution":"unique-catalog-title"}],"boosts":[{"id":"262349447","handle":"lockets-up-to-15-mm-high","observed":"Up to 15 mm high"}],"hides":[],"hideTags":[],"source":"boost-small-locket.txt"},{"key":"boost-square","name":"square","condition":"Contain","terms":["square"],"singularPlural":true,"pins":[{"position":1,"id":"7384476057665","handle":"sapphire-book-locket","observed":"Sapphire Book Locket","resolution":"unique-catalog-title"},{"position":2,"id":"7076322836545","handle":"white-topaz-petite-locket-necklace","observed":"White Topaz Petite Locket Necklace","resolution":"unique-catalog-title"},{"position":3,"id":"7325204906049","handle":"mens-gold-octagon-locket","observed":"Men's Gold Octagon Locket","resolution":"unique-catalog-title"},{"position":4,"id":"4550362300481","handle":"plain-book-locket","observed":"Plain Book Locket","resolution":"unique-catalog-title"},{"position":5,"id":"4549204017217","handle":"contemporary-sparkle-locket","observed":"Contemporary Sparkle Locket","resolution":"unique-catalog-title"},{"position":6,"id":"749221150828","handle":"contemporary-pink-tipped-square-locket","observed":"Contemporary Garnet Tipped Locket","resolution":"unique-catalog-title"},{"position":7,"id":"6580812546113","handle":"plain-10-photo-book-locket","observed":"10 Photo Plain Book Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-square.txt"},{"key":"boost-wedding","name":"Wedding","condition":"Contain","terms":["wedding","bridal","bridle"],"singularPlural":true,"pins":[{"position":1,"id":"6864857927","handle":"dainty-dazzle-heart-locket","observed":"Dainty Dazzle Locket","resolution":"unique-catalog-title"},{"position":2,"id":"6317356743","handle":"white-gold-and-mother-of-pearl-locket","observed":"White Gold and Mother of Pearl Locket","resolution":"unique-catalog-title"},{"position":3,"id":"15014499844474","handle":"cultured-pearl-silver-necklace","observed":"Cultured Pearl Silver Necklace","resolution":"unique-catalog-title"}],"boosts":[],"hides":[{"id":"3925835513921","handle":"gift-wrap","observed":"Product Option - Gift Wrap","resolution":"unique-catalog-title"}],"hideTags":[],"source":"boost-wedding.txt"},{"key":"boost-white-gold","name":"white gold","condition":"Contain","terms":["white gold"],"singularPlural":true,"pins":[{"position":1,"id":"2042943635521","handle":"hand-engraved-white-gold-floral-locket","observed":"Hand Engraved White Gold Bouquet Locket","resolution":"unique-catalog-title"},{"position":2,"id":"6976279478337","handle":"premium-petite-white-gold-and-diamond-locket","observed":"Premium Petite White Gold and Diamond Locket","resolution":"unique-catalog-title"},{"position":3,"id":"147536379924","handle":"three-photo-diamond-locket-33-mm","observed":"Diamond Wave Pavé Locket","resolution":"unique-catalog-title"},{"position":4,"id":"6345811271","handle":"18-ct-white-gold-floral-heart-locket","observed":"18 ct White Gold Floral Heart Locket","resolution":"unique-catalog-title"},{"position":5,"id":"1907414696001","handle":"cherub-micromosaic-locket-25-mm","observed":"Cherub Micromosaic Locket","resolution":"unique-catalog-title"},{"position":6,"id":"6471098951","handle":"diamond-and-onyx-white-gold-locket","observed":"Diamond and Onyx White Gold Locket","resolution":"unique-catalog-title"},{"position":7,"id":"6317008327","handle":"red-rose-guilloche-locket","observed":"Red Rose Guilloche Locket","resolution":"unique-catalog-title"}],"boosts":[],"hides":[],"hideTags":[],"source":"boost-white-gold.txt"}],"precedence":"Exact Are rules before Contain; then longest matched phrase; ties stable rule key. The most specific active rule with pins owns positions. Collection boosts accumulate only for eligible products. This is explicit draft policy, not a claim about proprietary Boost precedence."};
  var MAX_QUERIES = 6;
  var insignificant = ['a', 'an', 'and', 'the', 'of', 'for', 'to', 'with'];
  var gemstones = ['amber','amethyst','aquamarine','citrine','cubic zirconia','diamond','emerald','garnet','lapis lazuli','marcasite','moonstone','mother of pearl','onyx','opal','pearl','ruby','sapphire','topaz','turquoise'];
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim().replace(/\s+/g, ' ');
  }
  function singular(word) {
    if (word === 'children') return 'child';
    if (word.length > 4 && /ies$/.test(word)) return word.slice(0, -3) + 'y';
    if (word.length > 3 && /s$/.test(word) && !/(ss|us|is)$/.test(word)) return word.slice(0, -1);
    return word;
  }
  function words(value) { return normalize(value).split(' ').filter(Boolean).map(function (word) { return word==='four' ? '4' : word; }); }
  function phrase(value, part) { return (' ' + normalize(value) + ' ').indexOf(' ' + normalize(part) + ' ') !== -1; }
  function key(item) { return String(item.key || (item.kind || 'product') + ':' + (item.id || item.url || '')); }
  function advanced(q) { return /["“”]|(?:^|\s)(?:OR|AND|NOT)(?:\s|$)|(?:^|\s)-\S|\b[\w.]+:|[()*]/.test(q); }
  function plan(q) {
    q = String(q || '');
    var result = {queries: [q], aliases: [], nativeOnly: advanced(q)};
    if (result.nativeOnly || !normalize(q)) return result;
    var normalized = normalize(q);
    var edges = [];
    config.synonyms.concat(config.customAliases || []).forEach(function (row) {
      edges.push({from: row.from, to: row.to});
      if (row.both) edges.push({from: row.to, to: row.from});
    });
    edges.sort(function (a,b) { return normalize(b.from).length - normalize(a.from).length; });
    edges.forEach(function (edge) {
      if (result.queries.length >= MAX_QUERIES || !phrase(normalized, edge.from)) return;
      var source = ' ' + normalize(edge.from) + ' ';
      var expanded = (' ' + normalized + ' ').replace(source, ' ' + edge.to + ' ').trim();
      if (result.queries.some(function (existing) { return existing.toLowerCase().trim() === expanded.toLowerCase().trim(); })) return;
      result.queries.push(expanded);
      result.aliases.push({query: expanded, from: edge.from, to: edge.to});
    });
    return result;
  }
  var scoringCache = null;
  function fields(item) {
    if (scoringCache && scoringCache.fields.has(item)) return scoringCache.fields.get(item);
    var metadata = item.search || {};
    var options = (metadata.options || []).flatMap(function (option) { return [option.name].concat(option.values || []); });
    var variants = item.variants || [];
    var result = {
      title: words(item.title),
      medium: words([].concat(item.tags || [], metadata.type || '', options, variants.map(function (v) { return v.title || ''; })).join(' ')),
      gemstone: words((Array.isArray(item.tags) ? item.tags : []).filter(function (tag) {
        return gemstones.indexOf(String(tag).trim().toLowerCase().replace(/\s+/g,' '))!==-1;
      }).join(' ')),
      description: words([metadata.description || '', metadata.category || ''].join(' ')),
      identifiers: words(variants.map(function (v) { return [v.sku || '', v.barcode || ''].join(' '); }).join(' '))
    };
    if (scoringCache) scoringCache.fields.set(item,result);
    return result;
  }
  function tokenMatch(token, haystack, partial, shortTitlePrefix) {
    token = singular(token);
    return haystack.some(function (word) { return singular(word) === token || (partial && (token.length >= 3 || shortTitlePrefix) && word.indexOf(token) === 0); });
  }
  function terms(q) {
    if (scoringCache && scoringCache.terms.has(q)) return scoringCache.terms.get(q);
    var result = words(q).filter(function (word) { return insignificant.indexOf(word) === -1; });
    if (scoringCache) scoringCache.terms.set(q,result);
    return result;
  }
  function score(item, q, alias, allowPrefix) {
    var data = fields(item), tokens = terms(q), total = 0;
    if (!tokens.length) return 0;
    if (photoCapacity(q) && !photoCapacityMatch(item)) return 0;
    for (var i=0;i<tokens.length;i+=1) {
      var partial = !!allowPrefix && i === tokens.length - 1;
      if (tokenMatch(tokens[i], data.title, partial, true)) total += 80;
      else if (tokenMatch(tokens[i], data.medium, partial)) total += 24;
      else if (!alias && tokenMatch(tokens[i], data.description, partial)) total += 16;
      else if (!alias && tokenMatch(tokens[i], data.identifiers, false)) total += 8;
      else return 0;
    }
    if (normalize(item.title) === normalize(q)) total += 1000;
    else if (phrase(item.title, q)) total += 160;
    return total;
  }
  function photoCapacity(q) { return phrase(words(q).map(singular).join(' '),'4 photo'); }
  function photoCapacityMatch(item) {
    var title=words(item.title).map(singular).join(' ');
    if (phrase(title,'4 photo') || phrase(title,'4 photograph')) return true;
    var tags=(item.tags || []).map(function (tag) { return words(tag).map(singular).join(' '); });
    if (tags.some(function (tag) { return tag==='publictag 4 photo'; })) return true;
    if (tags.some(function (tag) { return /^publictag (?:one|two|three|\d+|six|ten) photo$/.test(tag); })) return false;
    return tags.some(function (tag) { return tag==='4 photo' || tag==='4 photo locket'; });
  }
  function attribute(q) {
    var value = normalize(q).split(' ').map(singular).join(' ');
    if (gemstones.indexOf(value) !== -1) return {kind:'gemstone', value:value};
    if (value==='brown') return {kind:'colour',value:value};
    if (['silver','sterling silver','gold','white gold','rose gold','yellow gold','platinum','stainless steel'].indexOf(value) !== -1) return {kind:'metal',value:value};
    if (['heart','oval','round','square'].indexOf(value) !== -1) return {kind:'shape',value:value};
    return null;
  }
  function attributeMatch(item, attr) {
    if (attr.kind==='colour') return score(item,'brown',false,false)>0 || attributeMatch(item,{kind:'gemstone',value:'amber'});
    if (phrase(item.title,attr.value)) return true;
    var tags = item.tags || [];
    if (attr.kind === 'gemstone') return tags.some(function (tag) { return normalize(tag) === attr.value; });
    var prefix = attr.kind === 'metal' ? 'publictagmetal ' : 'publictagshape ';
    var target = attr.value === 'sterling silver' ? 'silver' : attr.value;
    var authoritative=tags.map(normalize).filter(function (tag) {
      return tag.indexOf(prefix)===0 || (attr.kind==='metal' ? tag.indexOf('metal ')===0 : ['heart','oval','round','square'].indexOf(tag)!==-1);
    });
    if (authoritative.length) return authoritative.some(function (tag) { return phrase(tag,target); });
    // Some legitimate products have only legacy descriptions; missing structured tags are not a rejection.
    return score(item,attr.value,false,false)>0;
  }
  function near(a,b) {
    if (a===b) return true;
    if (a[0]!==b[0] || Math.abs(a.length-b.length)>1) return false;
    var i=0,j=0,errors=0;
    while (i<a.length && j<b.length) {
      if (a[i]===b[j]) { i+=1; j+=1; continue; }
      if (++errors>1) return false;
      if (a.length>b.length) i+=1;
      else if (b.length>a.length) j+=1;
      else { i+=1; j+=1; }
    }
    return errors + (i<a.length || j<b.length ? 1 : 0) <= 1;
  }
  function typoScore(item,q) {
    if (photoCapacity(q) && !photoCapacityMatch(item)) return 0;
    var data=fields(item), tokens=terms(q), typos=0;
    for (var i=0;i<tokens.length;i+=1) {
      var token=tokens[i];
      if (tokenMatch(token,data.title.concat(data.medium,data.description,data.identifiers),false)) continue;
      if (typos || token.length<4 || !data.title.concat(data.gemstone).some(function (word) { return near(singular(token),singular(word)); })) return 0;
      typos+=1;
    }
    return typos===1 ? 40 : 0;
  }
  function canonicalGemstoneQuery(q) {
    if (advanced(String(q || ''))) return null;
    var tokens=words(q), candidates=new Set();
    var dictionary=Array.from(new Set(gemstones.join(' ').split(' ')));
    tokens.forEach(function (token,index) {
      var term=singular(token);
      if (term.length<4 || dictionary.indexOf(term)!==-1 || attribute(term)) return;
      dictionary.forEach(function (word) {
        if (word.length<4 || !near(term,word)) return;
        var corrected=tokens.slice(); corrected[index]=word;
        var query=corrected.join(' ');
        // Multiword stones must still be present as a complete known phrase.
        if (gemstones.some(function (gem) { return words(gem).indexOf(word)!==-1 && phrase(query,gem); })) candidates.add(query);
      });
    });
    return candidates.size===1 ? Array.from(candidates)[0] : null;
  }
  function canonicalGemstoneMatch(item,gem) {
    if ((item.kind || 'product')!=='product') return true;
    var title=words(item.title).map(singular).join(' ');
    if (phrase(title,gem)) return true;
    // A merchandising/internal tag, SKU, option or category containing the word
    // is not gemstone evidence. Exact curated facet labels remain authoritative.
    if ((item.tags || []).some(function (tag) { return String(tag).trim().toLowerCase().replace(/\s+/g,' ')===gem; })) return true;
    // Typo canonicalization already populated these normalized fields in this
    // apply call. Missing exact tokens cannot become a description phrase after
    // cross-sell removal. Do not build a cache merely for this cheap rejection.
    var cached=scoringCache && scoringCache.fields.get(item);
    if (cached && !words(gem).every(function (token) { return tokenMatch(token,cached.description,false); })) return false;
    return phrase(productDescription(item.search && item.search.description || ''),gem);
  }
  function productDescription(description) {
    // Ignore an explicit reference to a matching product, not ordinary wording
    // such as "a matching pair" or "matching colour". Keep the item's own
    // description before the cross-sell and independent later sentences.
    return String(description).split(/[.!?\n]+/).map(function (sentence) {
      var reference=/\b(?:match(?:es|ing)?(?:\s+(?:perfectly|beautifully|well|also)){0,3}\s+with|matches|(?:the|our)\s+matching)\b/gi;
      var found;
      while ((found=reference.exec(sentence))) {
        var rest=sentence.slice(reference.lastIndex,reference.lastIndex+160);
        var product=/\b(?:lockets?|earrings?|necklaces?|rings?|bracelets?|bangles?|cufflinks?|keyrings?|charms?|chains?|pendants?|brooch(?:es)?)\b/i.exec(rest);
        if (product && !/\b(?:pair|colou?r)\b/i.test(rest.slice(0,product.index))) {
          return words(sentence.slice(0,found.index)).map(singular).join(' ');
        }
      }
      return words(sentence).map(singular).join(' ');
    }).join(' ');
  }
  function eligible(item) {
    if (item.hidden === true || item.hidden === 'true') return false;
    if ((item.kind || 'product') !== 'product') return true;
    var tags = item.tags || [], type = item.search && item.search.type || item.type || '';
    if (tags.some(function (tag) { return ['BOLD_HIDDEN_PRODUCT','pfs:hidden','pfs:hidden:s'].indexOf(tag)!==-1; }) || type==='OPTIONS_HIDDEN_PRODUCT') return false;
    var variants = item.variants || [];
    return variants.length ? variants.some(function (v) { return v.available===true || v.available==='true'; }) : item.available===true || item.available==='true';
  }
  var otherProductKinds = ['earring','ring','bracelet','bangle','cufflink','keyring','charm','chain','pendant','brooch'];
  function locketIntent(q) {
    var tokens=terms(q).map(singular);
    return tokens.some(function (token) { return token==='locket' || token==='loket'; }) &&
      !tokens.some(function (token) { return otherProductKinds.indexOf(token)!==-1; });
  }
  function locketIntentMatch(item) {
    if ((item.kind || 'product')!=='product') return true;
    var metadata=item.search || {};
    // Rings, bracelets, cufflinks and keyrings can themselves be genuine lockets.
    if (tokenMatch('locket',words(item.title).concat(words(metadata.type)),false)) return true;
    var tags=Array.isArray(item.tags) ? item.tags : [];
    if (tags.some(function (tag) {
      var value=normalize(tag);
      return value==='locket' || value==='lockets' ||
        /^photo (?:one|two|three|four|five|six|seven|eight|nine|ten|[1-9]\d*)$/.test(value) ||
        /^publictag (?:one|two|three|four|five|six|seven|eight|nine|ten|[1-9]\d*) photos?(?: locket rings?)?$/.test(value);
    })) return true;
    // A description mentioning matching lockets does not turn a definite accessory
    // into a locket. Generic or missing taxonomy is deliberately left unchanged.
    return ![metadata.type,metadata.category].some(function (value) {
      return otherProductKinds.indexOf(words(value).map(singular).join(' '))!==-1;
    });
  }
  function earringsIntent(q) {
    var tokens=terms(q).map(singular);
    return tokens.indexOf('earring')!==-1 && !tokens.some(function (token) {
      return token==='locket' || token==='loket' || token==='necklace' ||
        (token!=='earring' && otherProductKinds.indexOf(token)!==-1);
    });
  }
  function earringsIntentMatch(item) {
    if ((item.kind || 'product')!=='product') return true;
    var metadata=item.search || {}, tags=Array.isArray(item.tags) ? item.tags : [];
    if (tokenMatch('earring',words(item.title).concat(words(metadata.type),words(metadata.category)),false) ||
        tags.some(function (tag) { return /^earrings?$/.test(String(tag).trim().toLowerCase()); })) return true;
    // Keep descriptive cross-sells from satisfying a single-kind earrings request.
    // Unknown/generic taxonomy and explicitly mixed requests retain their old meaning.
    return ![metadata.type,metadata.category].some(function (value) {
      var tokens=words(value).map(singular);
      return tokens.indexOf('locket')!==-1 || otherProductKinds.indexOf(tokens.join(' '))!==-1;
    });
  }
  function activeRules(q) {
    return config.rules.map(function (rule) {
      var query = words(q).map(function (w) { return rule.singularPlural ? singular(w) : w; }).join(' ');
      var matched = rule.terms.filter(function (term) {
        var value=words(term).map(function (w) { return rule.singularPlural ? singular(w) : w; }).join(' ');
        return rule.condition==='Are' ? query===value : phrase(query,value);
      });
      return {rule:rule,length:matched.reduce(function (max,t) { return Math.max(max,normalize(t).length); },0)};
    }).filter(function (row) { return row.length>0; }).sort(function (a,b) {
      return Number(b.rule.condition==='Are') - Number(a.rule.condition==='Are') || b.length-a.length || a.rule.key.localeCompare(b.rule.key);
    }).map(function (row) { return row.rule; });
  }
  function applyRecords(items,q,options) {
    options=options || {};
    var queryPlan=plan(q), seen=new Set();
    var candidates=(items || []).filter(function (item) { var id=key(item); if (seen.has(id)||!eligible(item)) return false; seen.add(id); return true; });
    if (queryPlan.nativeOnly) return candidates;
    var possibleCanonical=!options.canonicalGemstone && canonicalGemstoneQuery(q);
    // A constituent like "pearl" must not reject "moter of pearl" before its
    // complete known phrase is corrected. Literal original matches still win.
    var queryGems=possibleCanonical ? [] : gemstones.filter(function (gem) { return phrase(words(q).map(singular).join(' '),gem); });
    queryGems=queryGems.filter(function (gem) { return !queryGems.some(function (longer) { return longer!==gem && phrase(longer,gem); }); });
    if (queryGems.length) candidates=candidates.filter(function (item) {
      return queryGems.every(function (gem) { return canonicalGemstoneMatch(item,gem); });
    });
    if (locketIntent(q)) candidates=candidates.filter(locketIntentMatch);
    if (earringsIntent(q)) candidates=candidates.filter(earringsIntentMatch);
    var originalKeys=new Set(options.originalKeys || candidates.map(key));
    var attr=attribute(q), rules=activeRules(q);
    var occasionWords=['wedding','bridal','bridle','birthday','anniversary'];
    var normalizedWords=words(q).map(singular);
    var occasion=normalizedWords.some(function (word) { return occasionWords.indexOf(word)!==-1; });
    var occasionModifiers=normalizedWords.filter(function (word) { return occasionWords.indexOf(word)===-1; }).join(' ');
    var occasionAttribute=attribute(occasionModifiers);
    var rows=candidates.map(function (item,index) {
      var original=originalKeys.has(key(item));
      var direct=score(item,q,false,true);
      if (attr && !attributeMatch(item,attr)) direct=0;
      var aliasScore=queryPlan.aliases.reduce(function (best,alias) { var aliasAttr=attribute(alias.query); return Math.max(best,!aliasAttr || attributeMatch(item,aliasAttr) ? score(item,alias.query,true,false) : 0); },0);
      return {item:item,index:index,score:original ? direct : 0,alias:aliasScore,original:original};
    });
    var directExists=rows.some(function (row) { return row.original && row.score>0; });
    var qTokens=terms(q);
    // A recognized gemstone misspelling can use the same EXACT fields as the
    // correct spelling. This is not fuzzy description matching: keep every other
    // term, product-intent/attribute guard and original-source provenance intact.
    // Literal original matches win; advanced syntax and ambiguous corrections do
    // not enter this path, and it does not add retrieval requests or a second typo.
    var canonical=!directExists ? possibleCanonical : null;
    if (canonical) {
      var correctedGem=gemstones.find(function (gem) { return phrase(canonical,gem) && !phrase(words(q).map(singular).join(' '),gem); });
      if (correctedGem) return applyRecords(items,canonical,Object.assign({},options,{canonicalGemstone:correctedGem}));
    }
    // At most one typo supported by a title or exact curated gemstone tag.
    // Every other term must still match; never fuzzy-expand aliases or cross-sell descriptions.
    if (!directExists && !attr && qTokens.length && !options.canonicalGemstone) {
      rows.forEach(function (row) {
        if (row.original) row.score=typoScore(row.item,q);
      });
      directExists=rows.some(function (row) { return row.original && row.score>0; });
    }
    var singletonOriginal=rows.filter(function (row) { return row.original; }).length===1;
    rows=rows.filter(function (row) {
      // Preserve a unique original nonliteral match (for example brown -> Amber), not a broad OR fallback.
      var occasionMatch=occasion && (!terms(occasionModifiers).length || (score(row.item,occasionModifiers,false,true)>0 && (!occasionAttribute || attributeMatch(row.item,occasionAttribute))));
      var retainIntent=row.original && !attr && (occasionMatch || (!directExists && singletonOriginal && qTokens.length===1 && options.complete!==false));
      row.score=Math.max(row.score,row.alias ? row.alias * 0.85 : 0);
      return row.score>0 || retainIntent;
    }).filter(function (row) {
      return !rules.some(function (rule) {
        return rule.hides.some(function (hidden) { return hidden.id && String(row.item.id)===hidden.id; }) || rule.hideTags.some(function (tag) { return (row.item.tags || []).indexOf(tag)!==-1; });
      });
    });
    rows.forEach(function (row) {
      var memberships=(row.item.search && row.item.search.collections || []).map(function (collection) { return String(collection.id); });
      row.boost=rules.reduce(function (count,rule) { return count+rule.boosts.filter(function (boost) { return memberships.indexOf(boost.id)!==-1; }).length; },0);
    });
    rows.sort(function (a,b) { return b.boost-a.boost || b.score-a.score || a.index-b.index; });
    // The most specific active pin rule owns positions; lower-priority collection boosts still apply.
    var pinRule=rules.find(function (rule) { return rule.pins.length; });
    if (pinRule) {
      var pins=pinRule.pins.map(function (pin) { return {position:pin.position,row:rows.find(function (row) { return pin.id && String(row.item.id)===pin.id; })}; }).filter(function (pin) { return pin.row; });
      var pinnedKeys=new Set(pins.map(function (pin) { return key(pin.row.item); }));
      rows=rows.filter(function (row) { return !pinnedKeys.has(key(row.item)); });
      pins.sort(function (a,b) { return a.position-b.position; }).forEach(function (pin) { rows.splice(Math.min(pin.position-1,rows.length),0,pin.row); });
    }
    return rows.map(function (row) { return row.item; });
  }
  function apply(items,q,options) {
    // Repeated direct, synonym and typo scores share preparation only during this
    // call. Restore the outer cache for reentrant calls and release it on errors.
    var previousCache = scoringCache;
    scoringCache = { fields:new WeakMap(), terms:new Map() };
    try { return applyRecords(items,q,options); }
    finally { scoringCache = previousCache; }
  }
  var api={version:config.version,metadataSchema:1,config:config,plan:plan,apply:apply,normalize:normalize,activeRules:activeRules,canonicalGemstoneQuery:canonicalGemstoneQuery};
  global.TLTSearchPolicy=api;
  if (typeof module!=='undefined' && module.exports) module.exports=api;
})(typeof window!=='undefined' ? window : globalThis);
/* END BUNDLED TLT SEARCH POLICY */
/* The Locket Tree: one complete matching and availability pipeline for the header and results page. */
(function (global) {
  'use strict';

  // The header and results section may load this asset together; keep one API and cache.
  if (global.TLTSearch && global.TLTSearch.version === '20261024-native-currency-v15') {
    if (typeof module !== 'undefined' && module.exports) module.exports = global.TLTSearch;
    return;
  }

  var CACHE_TTL = 5 * 60 * 1000;
  var CACHE_LIMIT = 8;
  var SESSION_CACHE_KEY = 'tlt-search-completed-v15';
  var SEARCH_CONCURRENCY = 6;
  var LARGE_SINGLE_QUERY_CONCURRENCY = 10;
  var SESSION_CACHE_LIMIT = 2;
  // sessionStorage counts UTF-16 characters; leave room for the shop's other storage.
  var SESSION_ENTRY_LIMIT = 1000000;
  var SESSION_TOTAL_LIMIT = 1500000;
  var allowedSorts = ['relevance', 'price-ascending', 'price-descending'];

  function integer(value, fallback) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number >= 0 ? number : fallback;
  }

  function priceInput(value) {
    if (value == null || String(value).trim() === '') return null;
    var number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
  }

  function readState(url) {
    var params = new URL(url).searchParams;
    return {
      q: params.get('q') || '',
      page: Math.max(1, integer(params.get('page'), 1)),
      sort: allowedSorts.indexOf(params.get('sort_by')) !== -1 ? params.get('sort_by') : 'relevance',
      availability: params.get('availability') === 'show' ? 'show' : 'hide',
      min: priceInput(params.get('filter.v.price.gte')),
      max: priceInput(params.get('filter.v.price.lte'))
    };
  }

  function stateUrl(currentUrl, state) {
    var url = new URL(currentUrl);
    url.searchParams.set('q', state.q);
    url.searchParams.set('sort_by', state.sort);
    if (state.page > 1) url.searchParams.set('page', String(state.page));
    else url.searchParams.delete('page');
    // Native requests are always fetched unfiltered. This URL describes our displayed union.
    if (state.availability === 'show') {
      url.searchParams.set('availability', 'show');
      url.searchParams.delete('filter.v.availability');
    } else {
      url.searchParams.delete('availability');
      url.searchParams.set('filter.v.availability', '1');
    }
    [['filter.v.price.gte', state.min], ['filter.v.price.lte', state.max]].forEach(function (entry) {
      if (entry[1] == null) url.searchParams.delete(entry[0]);
      else url.searchParams.set(entry[0], String(entry[1]));
    });
    return url;
  }

  function dataUrl(baseUrl, currentUrl, q, sectionId, page, predictive) {
    var current = new URL(currentUrl);
    var url = new URL(baseUrl, current);
    // Never inherit display filters, page limits or a rewritten search term.
    url.search = '';
    url.searchParams.set('q', q);
    url.searchParams.set('section_id', sectionId);
    ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    if (predictive) {
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag,variants.sku');
    } else {
      url.searchParams.set('page', String(page));
      url.searchParams.set('sort_by', 'relevance');
      // Unavailable products cannot enter the shared policy result, so avoid fetching
      // their native pages. Keep capped predictive ordering unchanged above.
      url.searchParams.set('options[unavailable_products]', 'hide');
    }
    return url;
  }

  function itemKey(item) {
    return String(item.key || ((item.kind || 'product') + ':' + (item.id || item.url || '')));
  }

  function isHidden(item) {
    return item.hidden === true || item.hidden === 'true';
  }

  function mergeItems(nativeItems, predictiveItems) {
    var items = new Map();
    // Native records have full variant information; predictive order supplies the initial ranking.
    var nativeByKey = new Map(nativeItems.map(function (item) { return [itemKey(item), item]; }));
    var hiddenKeys = new Set(nativeItems.concat(predictiveItems).filter(isHidden).map(itemKey));
    predictiveItems.concat(nativeItems).forEach(function (item) {
      var key = itemKey(item);
      var nativeItem = nativeByKey.get(key);
      if (hiddenKeys.has(key) || items.has(key)) return;
      items.set(key, nativeItem ? Object.assign({}, item, nativeItem) : item);
    });
    return Array.from(items.values());
  }

  function matches(item, state) {
    if (isHidden(item)) return false;
    if ((item.kind || 'product') !== 'product') {
      return state.min == null && state.max == null;
    }
    var variants = Array.isArray(item.variants) && item.variants.length ? item.variants : [item];
    var min = state.min == null ? null : Math.round(state.min * 100);
    var max = state.max == null ? null : Math.round(state.max * 100);
    return variants.some(function (variant) {
      var price = Number(variant.price);
      if (state.availability === 'hide' && variant.available !== true) return false;
      if ((min != null || max != null) && !Number.isFinite(price)) return false;
      return (min == null || price >= min) && (max == null || price <= max);
    });
  }

  function filterAndSort(items, state) {
    state = Object.assign({ availability: 'hide', sort: 'relevance', min: null, max: null }, state);
    var result = items.filter(function (item) { return matches(item, state); });
    if (state.sort === 'relevance') return result;
    var direction = state.sort === 'price-descending' ? -1 : 1;
    return result.map(function (item, index) { return { item: item, index: index }; }).sort(function (a, b) {
      var aProduct = (a.item.kind || 'product') === 'product';
      var bProduct = (b.item.kind || 'product') === 'product';
      if (aProduct !== bProduct) return aProduct ? -1 : 1;
      var difference = (Number(a.item.price) - Number(b.item.price)) * direction;
      return (Number.isFinite(difference) && difference !== 0) ? difference : a.index - b.index;
    }).map(function (entry) { return entry.item; });
  }

  function validatePage(payload, expectedPage) {
    if (!payload || !Array.isArray(payload.items)) throw new Error('Search data is missing.');
    var total = integer(payload.total, -1);
    var pages = integer(payload.pages, -1);
    var page = integer(payload.page, -1);
    if (total < 0 || pages < 0 || page < 1 || page !== expectedPage || (total > 0 && pages < 1)) {
      throw new Error('Search pagination is invalid.');
    }
    return { total: total, pages: Math.max(1, pages), page: page, items: payload.items };
  }

  async function loadNativePages(firstPayload, fetchPage, concurrency) {
    var first = validatePage(firstPayload, 1);
    var pages = new Array(first.pages);
    pages[0] = first.items;
    var next = 2;
    async function worker() {
      while (next <= first.pages) {
        var pageNumber = next++;
        var page = validatePage(await fetchPage(pageNumber), pageNumber);
        if (page.total !== first.total || page.pages !== first.pages) {
          throw new Error('Search results changed while loading. Please try again.');
        }
        pages[pageNumber - 1] = page.items;
      }
    }
    await Promise.all(Array.from({ length: Math.min(concurrency || 3, Math.max(0, first.pages - 1)) }, worker));
    var items = [].concat.apply([], pages);
    if (items.length !== first.total) throw new Error('Not all search results were received.');
    var distinct = new Set(items.map(itemKey));
    if (distinct.size !== items.length) throw new Error('Search results changed while loading. Please try again.');
    return items;
  }

  function safeUrl(value, base) {
    try {
      var url = new URL(value || '', base);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (_) { return ''; }
  }

  function resultTitle(total, q, shopName) {
    return 'Search: ' + total + (total === 1 ? ' result' : ' results') + ' for "' + q + '" – ' + (shopName || 'The Locket Tree');
  }

  async function fetchSearchText(url, parentSignal, fetcher, timeoutMs) {
    var controller = new global.AbortController();
    var rejectStopped;
    var stopped = new Promise(function (_, reject) { rejectStopped = reject; });
    var onAbort = function () {
      rejectStopped(new global.DOMException('Search cancelled.', 'AbortError'));
      controller.abort();
    };
    if (parentSignal) {
      parentSignal.addEventListener('abort', onAbort, { once: true });
      if (parentSignal.aborted) onAbort();
    }
    var timer = global.setTimeout(function () {
      // Reject with an ordinary error before aborting transport so the retry message is shown.
      rejectStopped(new Error('Search took too long to load. Please try again.'));
      controller.abort();
    }, timeoutMs == null ? 20000 : timeoutMs);
    try {
      var request = Promise.resolve().then(async function () {
        if (controller.signal.aborted) throw new global.DOMException('Search cancelled.', 'AbortError');
        var requestUrl = new URL(url);
        var requestOptions = {
          signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' }
        };
        var response = await (fetcher || global.fetch)(requestUrl.href, requestOptions);
        var previewId = requestUrl.searchParams.get('preview_theme_id');
        var hasNestedSearchOptions = Array.from(requestUrl.searchParams.keys()).some(function (key) {
          return key.indexOf('resources[') === 0 || key.indexOf('options[') === 0;
        });
        if (response.redirected && /^\d+$/.test(previewId || '') && hasNestedSearchOptions) {
          // Shopify activates the preview cookie, then redirects. That redirect incorrectly serializes
          // nested resources[...] / options[...] parameters. Reissue the original parameters once,
          // using the now-active same-origin preview cookie, and verify its theme in fetchData below.
          if (!response.url || new URL(response.url).origin !== requestUrl.origin) {
            throw new Error('Search preview redirected outside this shop. Please reload the preview.');
          }
          if (response.body && typeof response.body.cancel === 'function') {
            try { await response.body.cancel(); } catch (_) {}
          }
          if (controller.signal.aborted) throw new global.DOMException('Search cancelled.', 'AbortError');
          var retryUrl = new URL(requestUrl);
          retryUrl.searchParams.delete('preview_theme_id');
          response = await (fetcher || global.fetch)(retryUrl.href, requestOptions);
          if (response.url && new URL(response.url).origin !== requestUrl.origin) {
            throw new Error('Search preview redirected outside this shop. Please reload the preview.');
          }
        }
        if (!response.ok) throw new Error('Search could not be loaded.');
        return response.text();
      });
      // The deadline also covers response-body reads, even if a transport fails to reject on abort.
      return await Promise.race([request, stopped]);
    } finally {
      global.clearTimeout(timer);
      if (parentSignal) parentSignal.removeEventListener('abort', onAbort);
    }
  }

  function cancelled(signal) {
    if (signal && signal.aborted) throw new global.DOMException('Search cancelled.', 'AbortError');
  }

  function validateThemePayload(payload, url) {
    var expected = new URL(url).searchParams.get('preview_theme_id');
    if (expected && (!/^\d+$/.test(expected) || !payload || String(payload.themeId) !== expected)) {
      throw new Error('Search returned a different theme. Please reload this draft preview.');
    }
    return payload;
  }

  function parseSearchData(html) {
    var document = new global.DOMParser().parseFromString(html, 'text/html');
    var data = document.querySelector('script[data-search-data]');
    if (!data) throw new Error('Search data is missing.');
    return JSON.parse(data.textContent);
  }

  function createDataFetcher(fetcher, parser, settings) {
    settings = settings || {};
    var verified = new Map();
    // Seed once from the rendered page, never from a preview query parameter.
    var pageContext = settings.pageContext;
    if (!pageContext && global.location && global.Shopify && global.Shopify.theme) {
      pageContext = { url:global.location.href, themeId:global.Shopify.theme.id };
    }
    if (pageContext && /^\d+$/.test(String(pageContext.themeId || ''))) {
      try {
        var pageUrl = new URL(pageContext.url);
        if (pageUrl.protocol === 'https:' || pageUrl.protocol === 'http:') {
          verified.set(pageUrl.origin,String(pageContext.themeId));
        }
      } catch (_) {}
    }
    var now = settings.now || Date.now;
    var timeout = settings.timeoutMs == null ? 20000 : settings.timeoutMs;
    return async function readData(url, signal) {
      var original = new URL(url);
      var previewId = original.searchParams.get('preview_theme_id');
      var previewSearch = /^\d+$/.test(previewId || '') && Array.from(original.searchParams.keys()).some(function (key) {
        return key.indexOf('resources[') === 0 || key.indexOf('options[') === 0;
      });
      var fast = previewSearch && verified.get(original.origin) === previewId;
      var deadline = now() + timeout;
      var request = async function (requestUrl) {
        cancelled(signal);
        var remaining = deadline - now();
        if (remaining <= 0) throw new Error('Search took too long to load. Please try again.');
        var html = await fetchSearchText(requestUrl, signal, async function (input, options) {
          var response = await (fetcher || global.fetch)(input, options);
          // Cookie reuse must never weaken the existing explicit-preview origin boundary.
          if (previewSearch && response.url && new URL(response.url).origin !== original.origin) {
            throw new Error('Search preview redirected outside this shop. Please reload the preview.');
          }
          return response;
        }, remaining);
        cancelled(signal);
        return validateThemePayload((parser || parseSearchData)(html), original);
      };
      var payload;
      try {
        var transportUrl = new URL(original);
        if (fast) transportUrl.searchParams.delete('preview_theme_id');
        payload = await request(transportUrl);
      } catch (error) {
        if (!fast || (signal && signal.aborted) || error.name === 'AbortError' || now() >= deadline ||
            /outside this shop/.test(error.message)) throw error;
        // Another tab can replace Shopify's preview cookie. Reactivate this explicit draft once,
        // then validate its identity again. Both attempts share one deadline and caller signal.
        verified.delete(original.origin);
        payload = await request(original);
      }
      if (previewSearch) {
        verified.set(original.origin, previewId);
        while (verified.size > 8) verified.delete(verified.keys().next().value);
      }
      return payload;
    };
  }

  var fetchData = createDataFetcher();

  function cacheKey(options, policy) {
    if (arguments.length < 2) policy = global.TLTSearchPolicy;
    var current = new URL(options.currentUrl);
    var shopify = global.Shopify || {};
    return JSON.stringify([
      new URL(options.searchUrl || '/search', current).href,
      new URL(options.predictiveUrl || '/search/suggest', current).href,
      options.currency || 'GBP', options.locale || '', options.country || shopify.country || '',
      current.searchParams.get('preview_theme_id') || String(options.themeId || (shopify.theme && shopify.theme.id) || ''),
      options.sectionId || 'tlt-search-data', options.predictiveSectionId || 'tlt-search-predictions',
      current.searchParams.get('preview_theme_id') || '',
      current.searchParams.get('_fd') || '', current.searchParams.get('pb') || '', options.q,
      policy ? String(policy.version) : 'transport-only'
    ]);
  }

  function displayRecords(items) {
    // Matching is complete before this point. Cache only display/filter fields: descriptions,
    // collection membership and SKU/barcode were retrieval evidence, not presentation data.
    // Clone rather than mutating source records retained by fixtures or a concurrent caller.
    return items.map(function (item) {
      var record = Object.assign({}, item);
      delete record.search;
      if (Array.isArray(item.variants)) record.variants = item.variants.map(function (variant) {
        var displayVariant = Object.assign({}, variant);
        delete displayVariant.sku;
        delete displayVariant.barcode;
        return displayVariant;
      });
      return record;
    });
  }

  // A factory keeps tests independent; the browser exposes one shared instance below.
  // Only completed result sets are cached. Each caller owns its in-flight work and cancellation.
  function createSearchLoader(loadData, settings) {
    settings = settings || {};
    var policy = Object.prototype.hasOwnProperty.call(settings, 'policy') ? settings.policy : global.TLTSearchPolicy;
    var cache = new Map();
    var now = settings.now || Date.now;
    var storage;
    try { storage = Object.prototype.hasOwnProperty.call(settings, 'storage') ? settings.storage : global.sessionStorage; } catch (_) {}
    try {
      if (storage && typeof storage.removeItem === 'function') {
        storage.removeItem('tlt-search-completed-v3');
        storage.removeItem('tlt-search-completed-v4');
        storage.removeItem('tlt-search-completed-v5');
        storage.removeItem('tlt-search-completed-v6');
        storage.removeItem('tlt-search-completed-v7');
        storage.removeItem('tlt-search-completed-v8');
        storage.removeItem('tlt-search-completed-v9');
        storage.removeItem('tlt-search-completed-v10');
        storage.removeItem('tlt-search-completed-v11');
        storage.removeItem('tlt-search-completed-v12');
        storage.removeItem('tlt-search-completed-v13');
      }
    } catch (_) {}
    function fresh(entry) {
      var age = entry && now() - entry.time;
      return !!entry && Number.isFinite(entry.time) && age >= 0 && age < CACHE_TTL;
    }
    function stamp(items, time) {
      // Consumers can expire their displayed snapshot using the original fetch time, even on a cache hit.
      Object.defineProperty(items, 'fetchedAt', { value: time, configurable: true });
      return items;
    }
    function storedEntries() {
      if (!storage) return [];
      try {
        var envelope = JSON.parse(storage.getItem(SESSION_CACHE_KEY));
        if (!envelope || envelope.version !== 15 || !Array.isArray(envelope.entries)) return [];
        return envelope.entries.slice(0, SESSION_CACHE_LIMIT).filter(function (entry) {
          return fresh(entry) && entry.complete === true && typeof entry.key === 'string' &&
            Array.isArray(entry.items) && entry.items.every(function (item) {
              return item && typeof item === 'object' && !Array.isArray(item) && (item.key || item.id || item.url);
            }) && new Set(entry.items.map(itemKey)).size === entry.items.length;
        });
      } catch (_) { return []; }
    }
    function saveStored(key, entry) {
      if (!storage) return;
      try {
        var entries = storedEntries().filter(function (candidate) { return candidate.key !== key; });
        if (entry && JSON.stringify(entry).length <= SESSION_ENTRY_LIMIT) entries.unshift(entry);
        entries = entries.slice(0, SESSION_CACHE_LIMIT);
        var serialized = JSON.stringify({ version: 15, entries: entries });
        while (serialized.length > SESSION_TOTAL_LIMIT && entries.length) {
          entries.pop();
          serialized = JSON.stringify({ version: 15, entries: entries });
        }
        storage.setItem(SESSION_CACHE_KEY, serialized);
      } catch (_) { /* Disabled storage or quota exhaustion must never break search. */ }
    }
    return async function getItems(options, signal, onProgress) {
      options = Object.assign({}, options, { q: String(options.q == null ? '' : options.q) });
      cancelled(signal);
      if (!options.q.trim()) return [];
      if (policy !== null && (!policy || typeof policy.plan !== 'function' || typeof policy.apply !== 'function')) {
        throw new Error('Search matching could not be loaded. Please reload the page.');
      }
      var key = cacheKey(options, policy);
      if (options.force) {
        cache.delete(key);
        saveStored(key, null);
      }
      var cached = cache.get(key);
      if (!options.force && fresh(cached)) return stamp(cached.items, cached.time);
      if (!options.force) {
        cached = storedEntries().find(function (entry) { return entry.key === key; });
        if (cached) {
          cache.set(key, cached);
          while (cache.size > CACHE_LIMIT) cache.delete(cache.keys().next().value);
          return stamp(cached.items, cached.time);
        }
      }
      var controller = new global.AbortController();
      var abort = function () { controller.abort(); };
      if (signal) signal.addEventListener('abort', abort, { once: true });
      var requestSignal = controller.signal;
      // One budget covers original pages, predictions and all aliases together.
      // Initial and alias work stays at six. Only a validated large single query
      // may use ten slots to avoid an unnecessary final native-page wave.
      // Original page one and its prediction are enqueued first to preserve early-card priority.
      var searchConcurrency = SEARCH_CONCURRENCY;
      var active = 0;
      var queue = [];
      function pump() {
        if (requestSignal.aborted) {
          while (queue.length) queue.shift().reject(new global.DOMException('Search cancelled.', 'AbortError'));
          return;
        }
        while (active < searchConcurrency && queue.length) {
          var job = queue.shift();
          active++;
          (function (task) {
            Promise.resolve().then(function () { cancelled(requestSignal); return loadData(task.url, requestSignal); }).then(function (payload) {
              // Completed compact caches return above; only fresh source records need matching metadata.
              if (policy && policy.metadataSchema && payload && Array.isArray(payload.items) && payload.items.some(function (item) {
                return !item || !item.search || item.search.schema !== policy.metadataSchema;
              })) throw new Error('Search matching data changed. Please reload the page and try again.');
              return payload;
            })
              .then(task.resolve, task.reject).finally(function () { active--; pump(); });
          })(job);
        }
      }
      requestSignal.addEventListener('abort', pump);
      function request(url) {
        return new Promise(function (resolve, reject) { queue.push({ url: url, resolve: resolve, reject: reject }); pump(); });
      }
      function relevant(items, complete, originalItems) {
        return policy ? policy.apply(items, options.q, { complete: complete,
          originalKeys: originalItems.map(itemKey) }) : items;
      }
      try {
        var plan = policy ? policy.plan(options.q) : { queries: [options.q] };
        if (!plan || !Array.isArray(plan.queries) || !plan.queries.length || plan.queries.length > 6 ||
            plan.queries.some(function (q) { return typeof q !== 'string' || !q.trim(); })) {
          throw new Error('Search matching could not be prepared.');
        }
        var queries = Array.from(new Set([options.q].concat(plan.queries)));
        if (queries.length > 6) throw new Error('Search has too many expansions.');
        var completedQueries = 0;
        var searches = queries.map(function (query) {
          var nativeUrl = function (page) {
            return dataUrl(options.searchUrl || '/search', options.currentUrl, query,
              options.sectionId || 'tlt-search-data', page, false);
          };
          var first = request(nativeUrl(1));
          var native = first.then(function (payload) {
            cancelled(requestSignal);
            var firstPage = validatePage(payload, 1);
            // Shopify search exposes at most 1,000 results. At the ceiling we cannot establish
            // a complete search population, so do not publish a misleading count or cache it.
            if (firstPage.total >= 1000) {
              var tooBroad = new Error('Please use a more specific search to see complete results.');
              tooBroad.code = 'SEARCH_QUERY_TOO_BROAD';
              throw tooBroad;
            }
            if (queries.length === 1 && firstPage.pages > SEARCH_CONCURRENCY + 1) {
              searchConcurrency = LARGE_SINGLE_QUERY_CONCURRENCY;
            }
            return loadNativePages(firstPage, function (page) { return request(nativeUrl(page)); }, searchConcurrency);
          });
          var predictive = plan.nativeOnly ? Promise.resolve([]) : request(dataUrl(options.predictiveUrl || '/search/suggest',
            options.currentUrl, query, options.predictiveSectionId || 'tlt-search-predictions', 1, true)).then(function (payload) {
            if (!payload || !Array.isArray(payload.items)) throw new Error('Search suggestions could not be loaded.');
            return payload.items;
          });
          var complete = Promise.all([native, predictive]).then(function (sources) { completedQueries++; return sources; });
          return { first: first, predictive: predictive, complete: complete };
        });
        var originalFirstReady = false;
        // Register before prediction progress: a later prediction must never replace
        // a newer native-plus-prediction preview with the smaller prediction-only set.
        searches[0].first.then(function () { originalFirstReady = true; }, function () {});
        var predictionProgress = typeof onProgress === 'function' && !plan.nativeOnly ? searches[0].predictive.then(function (items) {
          cancelled(requestSignal);
          cancelled(signal);
          if (originalFirstReady || !items.length) return;
          var originalPreview = mergeItems([], items);
          var earlyItems = relevant(originalPreview, false, originalPreview);
          if (earlyItems.length) onProgress({ items: earlyItems, complete: false, nativeLoaded: 0, nativeTotal: null });
        }) : Promise.resolve();
        var progressPromise = typeof onProgress === 'function' ? Promise.all([searches[0].first, searches[0].predictive]).then(function (sources) {
          cancelled(requestSignal);
          cancelled(signal);
          var first = validatePage(sources[0], 1);
          if ((first.pages > 1 || queries.length > 1) && completedQueries < queries.length) {
            // This is only the original-query preview. Later pages/aliases can add matches;
            // consumers must not publish totals or facet counts until the final array resolves.
            var originalPreview = mergeItems(first.items, sources[1]);
            onProgress({ items: relevant(originalPreview, false, originalPreview), complete: false,
              nativeLoaded: first.items.length, nativeTotal: first.total });
          }
        }) : Promise.resolve();
        var results = await Promise.all([Promise.all(searches.map(function (query) { return query.complete; })), progressPromise, predictionProgress]);
        cancelled(requestSignal);
        cancelled(signal);
        var fetchedAt = now();
        var sources = results[0];
        var matched = relevant(mergeItems([].concat.apply([], sources.map(function (source) { return source[0]; })),
          [].concat.apply([], sources.map(function (source) { return source[1]; }))), true, mergeItems(sources[0][0], sources[0][1]));
        var items = stamp(policy ? displayRecords(matched) : matched, fetchedAt);
        var entry = { key: key, time: fetchedAt, complete: true, items: items };
        cache.delete(key);
        cache.set(key, entry);
        while (cache.size > CACHE_LIMIT) cache.delete(cache.keys().next().value);
        saveStored(key, entry);
        return items;
      } catch (error) {
        // Cancel sibling requests rather than continuing a result set that cannot be complete.
        controller.abort();
        throw error;
      } finally {
        requestSignal.removeEventListener('abort', pump);
        if (signal) signal.removeEventListener('abort', abort);
      }
    };
  }

  var getItems = createSearchLoader(fetchData);

  function createCard(item, options) {
      options = options || {};
      var document = global.document;
      var baseUrl = options.baseUrl || global.location.href;
      var product = (item.kind || 'product') === 'product';
      var card = document.createElement('div');
      card.className = 'product-block tlt-search-card';
      if (product && item.id != null) card.dataset.productId = String(item.id);
      var inner = document.createElement('div');
      inner.className = 'block-inner';
      var content = document.createElement('div');
      content.className = 'block-inner-inner';
      inner.appendChild(content);
      card.appendChild(inner);
      var href = safeUrl(item.url, baseUrl);
      var imageContainer = document.createElement('div');
      imageContainer.className = 'image-cont';
      var imageLink = document.createElement('a');
      imageLink.className = 'product-link';
      imageLink.href = href || '#';
      imageLink.setAttribute('aria-hidden', 'true');
      imageLink.tabIndex = -1;
      var source = item.image && safeUrl(item.image, baseUrl);
      if (source) {
        var image = document.createElement('img');
        image.src = source;
        image.alt = item.imageAlt || item.title || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 600;
        image.height = 600;
        imageLink.appendChild(image);
      }
      imageContainer.appendChild(imageLink);
      content.appendChild(imageContainer);
      var info = document.createElement('div');
      info.className = 'product-block__detail tlt-search-info align-ltr-center';
      var detailInner = document.createElement('div');
      detailInner.className = 'inner';
      var detailInnerer = document.createElement('div');
      detailInnerer.className = 'innerer';
      var detailLink = document.createElement('a');
      detailLink.className = 'product-link';
      detailLink.href = href || '#';
      detailInnerer.appendChild(detailLink);
      detailInner.appendChild(detailInnerer);
      info.appendChild(detailInner);
      var title = document.createElement('div');
      title.className = 'product-block__title';
      title.textContent = item.title || 'View result';
      detailLink.appendChild(title);
      if (product) {
        var sourceCurrency = options.sourceCurrency || options.currency || 'GBP';
        var nativeAmount = item.tltBasePrice == null ? item.price : item.tltBasePrice;
        var price = document.createElement('div');
        price.className = 'product-price product-price--block';
        if (typeof item.priceHtml === 'string' && item.priceHtml.trim()) {
          // This field is rendered by the existing theme price snippet, preserving sale-price markup.
          price.innerHTML = item.priceHtml;
        } else {
          var amount = document.createElement('span');
          amount.className = 'price__current';
          amount.setAttribute('data-tlt-money-amount', String(nativeAmount));
          amount.setAttribute('data-tlt-money-currency', sourceCurrency);
          amount.textContent = new Intl.NumberFormat(options.locale || document.documentElement.lang || 'en-GB', {
            style: 'currency', currency: sourceCurrency
          }).format(Number(nativeAmount) / 100);
          price.appendChild(amount);
        }
        if (global.TLTCurrency) {
          var context = options.currencyContext || global.TLTCurrency.currencyContext(sourceCurrency, global);
          try {
            global.TLTCurrency.formatManagedPrices(price, context, {
              sourceCurrency: sourceCurrency, locale: options.locale, currentAmount: nativeAmount, host: global
            });
          } catch (_) {
            // Keep useful native prices if the display-conversion app is unavailable.
            global.TLTCurrency.formatManagedPrices(price, global.TLTCurrency.currencyContext(sourceCurrency, {}), {
              sourceCurrency: sourceCurrency, locale: options.locale, currentAmount: nativeAmount, host: global
            });
          }
        } else {
          price.querySelectorAll('span.money').forEach(function (node) { node.classList.remove('money'); });
        }
        detailLink.appendChild(price);
        if (item.available === false) {
          var soldOut = document.createElement('span');
          soldOut.className = 'tlt-search-sold-out';
          soldOut.textContent = 'Sold out';
          detailLink.appendChild(soldOut);
        }
      }
      content.appendChild(info);
      return card;
    }


  var api = { version: '20261024-native-currency-v15', readState: readState, stateUrl: stateUrl, dataUrl: dataUrl, itemKey: itemKey,
    mergeItems: mergeItems, matches: matches, filterAndSort: filterAndSort,
    validatePage: validatePage, loadNativePages: loadNativePages, safeUrl: safeUrl, resultTitle: resultTitle,
    fetchSearchText: fetchSearchText, fetchData: fetchData, createDataFetcher: createDataFetcher, validateThemePayload: validateThemePayload, createSearchLoader: createSearchLoader, cacheKey: cacheKey,
    getItems: getItems, createCard: createCard,
    currencyContext: global.TLTCurrency && global.TLTCurrency.currencyContext,
    formatManagedPrices: global.TLTCurrency && global.TLTCurrency.formatManagedPrices };
  global.TLTSearch = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.HTMLElement || !global.customElements || global.customElements.get('tlt-unified-search')) return;

  class UnifiedSearch extends global.HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.form = this.querySelector('[data-search-form]');
      this.results = this.querySelector('[data-search-results]');
      this.count = this.querySelector('[data-search-count]');
      this.controls = this.querySelector('[data-search-controls]');
      this.pagination = this.querySelector('[data-search-pagination]');
      this.status = this.querySelector('[data-search-status]');
      if (!this.form || !this.results || !this.count || !this.controls || !this.pagination || !this.status) return;
      this.pageSize = Math.max(1, integer(this.dataset.pageSize, 24));
      this.status.setAttribute('role', 'status');
      this.status.setAttribute('aria-live', 'polite');
      this.state = readState(global.location.href);
      this.onSubmit = (event) => {
        event.preventDefault();
        var input = this.form.querySelector('[name="q"]');
        this.state = Object.assign({}, this.state, { q: input ? input.value : '', page: 1 });
        this.navigate();
      };
      this.onControl = (event) => {
        if (!event.target.name) return;
        var selected = this.controls.querySelector('[name="availability"]:checked');
        var min = this.controls.querySelector('[name="price_min"]');
        var max = this.controls.querySelector('[name="price_max"]');
        var sort = this.controls.querySelector('[name="sort_by"]');
        this.state = Object.assign({}, this.state, {
          page: 1, availability: selected && selected.value === 'show' ? 'show' : 'hide',
          min: priceInput(min && min.value), max: priceInput(max && max.value),
          sort: sort && allowedSorts.indexOf(sort.value) !== -1 ? sort.value : 'relevance'
        });
        this.navigate();
      };
      this.onControlSubmit = (event) => {
        event.preventDefault();
        this.onControl({ target: { name: 'filters' } });
      };
      this.onPage = (event) => {
        var link = event.target.closest('a[data-page]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        this.state.page = Math.max(1, integer(link.dataset.page, 1));
        this.navigate();
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      this.onPopState = () => { this.state = readState(global.location.href); this.refresh(); };
      this.form.addEventListener('submit', this.onSubmit);
      this.controls.addEventListener('change', this.onControl);
      this.controls.addEventListener('submit', this.onControlSubmit);
      this.pagination.addEventListener('click', this.onPage);
      global.addEventListener('popstate', this.onPopState);
      this.refresh();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.form && this.onSubmit) this.form.removeEventListener('submit', this.onSubmit);
      if (this.controls && this.onControl) this.controls.removeEventListener('change', this.onControl);
      if (this.controls && this.onControlSubmit) this.controls.removeEventListener('submit', this.onControlSubmit);
      if (this.pagination && this.onPage) this.pagination.removeEventListener('click', this.onPage);
      if (this.onPopState) global.removeEventListener('popstate', this.onPopState);
      this.started = false;
    }

    navigate() {
      global.history.pushState(null, '', stateUrl(global.location.href, this.state));
      this.refresh();
    }

    syncControls() {
      var queryInput = this.form.querySelector('[name="q"]');
      if (queryInput) queryInput.value = this.state.q;
      this.controls.querySelectorAll('[name="availability"]').forEach((input) => {
        input.checked = input.value === this.state.availability;
      });
      [['price_min', this.state.min], ['price_max', this.state.max], ['sort_by', this.state.sort]].forEach((entry) => {
        var input = this.controls.querySelector('[name="' + entry[0] + '"]');
        if (input) input.value = entry[1] == null ? '' : String(entry[1]);
      });
    }

    async refresh() {
      if (this.controller) this.controller.abort();
      var controller = new global.AbortController();
      this.controller = controller;
      var q = this.state.q;
      this.syncControls();
      this.results.setAttribute('aria-busy', 'true');
      this.pagination.replaceChildren();
      this.status.textContent = 'Loading results…';
      this.count.textContent = '';
      if (this.renderedQuery !== undefined && this.renderedQuery !== q) this.results.replaceChildren();
      if (!q.trim()) {
        this.results.replaceChildren();
        this.status.textContent = 'Enter a search term.';
        this.results.setAttribute('aria-busy', 'false');
        return;
      }
      try {
        var items = await getItems({
          q: q, currentUrl: global.location.href,
          searchUrl: this.dataset.searchUrl || '/search',
          predictiveUrl: this.dataset.predictiveUrl || '/search/suggest',
          sectionId: this.dataset.sectionId || 'tlt-search-data',
          predictiveSectionId: this.dataset.predictiveSectionId || 'tlt-search-predictions',
          currency: this.dataset.currency || 'GBP',
          locale: this.dataset.locale || document.documentElement.lang
        }, controller.signal);
        if (controller.signal.aborted || this.controller !== controller) return;
        this.render(items);
        this.renderedQuery = q;
      } catch (error) {
        if (controller.signal.aborted || this.controller !== controller || error.name === 'AbortError') return;
        controller.abort();
        console.warn('Search could not load:', error.message);
        this.count.textContent = '';
        this.status.replaceChildren(document.createTextNode('We couldn’t load all the results. Any results below may be incomplete. '));
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'btn btn--secondary tlt-search-retry';
        retry.textContent = 'Try again';
        retry.addEventListener('click', () => this.refresh());
        this.status.appendChild(retry);
      } finally {
        if (this.controller === controller) this.results.setAttribute('aria-busy', 'false');
      }
    }

    render(items) {
      var matches = filterAndSort(items, this.state);
      var total = matches.length;
      var pages = Math.max(1, Math.ceil(total / this.pageSize));
      if (this.state.page > pages) {
        this.state.page = pages;
        global.history.replaceState(null, '', stateUrl(global.location.href, this.state));
      }
      var start = (this.state.page - 1) * this.pageSize;
      var fragment = document.createDocumentFragment();
      matches.slice(start, start + this.pageSize).forEach((item) => fragment.appendChild(createCard(item, {
        currency: this.dataset.currency || 'GBP',
        locale: this.dataset.locale || document.documentElement.lang,
        baseUrl: global.location.href
      })));
      this.results.replaceChildren(fragment);
      this.count.textContent = 'We found ' + total + (total === 1 ? ' result' : ' results');
      document.title = resultTitle(total, this.state.q, this.dataset.shopName);
      this.status.textContent = total ? '' : 'No results match your search and filters.';
      this.renderPagination(pages);
    }


    renderPagination(pages) {
      this.pagination.replaceChildren();
      if (pages <= 1) return;
      this.pagination.setAttribute('aria-label', 'Search result pages');
      var page = this.state.page;
      var numbers = new Set([1, pages]);
      for (var number = Math.max(1, page - 2); number <= Math.min(pages, page + 2); number++) numbers.add(number);
      var appendLink = (target, label) => {
        var link = document.createElement('a');
        link.href = stateUrl(global.location.href, Object.assign({}, this.state, { page: target })).href;
        link.dataset.page = String(target);
        link.textContent = label;
        if (target === page) link.setAttribute('aria-current', 'page');
        this.pagination.appendChild(link);
      };
      if (page > 1) appendLink(page - 1, 'Previous');
      var previous = 0;
      Array.from(numbers).sort(function (a, b) { return a - b; }).forEach((target) => {
        if (previous && target > previous + 1) {
          var gap = document.createElement('span');
          gap.textContent = '…';
          this.pagination.appendChild(gap);
        }
        appendLink(target, String(target));
        previous = target;
      });
      if (page < pages) appendLink(page + 1, 'Next');
    }
  }

  global.customElements.define('tlt-unified-search', UnifiedSearch);
})(typeof window !== 'undefined' ? window : globalThis);
